import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ReceiveItemListRes;
export const ReceiveItemListTodo = createAsyncThunk('ReceiveItemList', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'items_list',
            headers: { "Content-Type": "application/json" },
            data:{
                "iware_house_id": localStorage.getItem('iware_house_id'),
                "vitem_name": ''
            },
        })
        return ReceiveItemListRes = res.data

    } catch (error) {
        return ReceiveItemListRes = error.response.data
    }
});

const ReceiveItemListSlice = createSlice({
    name: 'ReceiveItemList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ReceiveItemListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(ReceiveItemListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default ReceiveItemListSlice.reducer; 